import { useKratosSession } from "@saflib/ory-kratos-sdk";
import { useGetOrganization } from "@vendata/power-up-sdk";

/**
 * The combined Account page reads the current Kratos session for personal
 * information (name / email / phone) and the org record for the inline
 * Company Profile form. Both queries are resolved by AsyncPage before
 * HomePage.vue renders so we don't have to guard against `undefined` data.
 */
export function useAccountHomeLoader() {
  return {
    sessionQuery: useKratosSession(),
    organizationQuery: useGetOrganization(),
  };
}
